<ejs-maps
  id="potential-map"
  style="display: block;"
  [width]="mapWidth"
  [height]="mapHeight"
  [layers]="layers"
  (shapeSelected)="mapClick($event)"
></ejs-maps>



  <app-modal-pot-per-reg-hospitals
  *ngIf="isActiveModalHospital"
  [regionId]="regionId"
  [regionName]="regionName"
  [countryId]="countryId"
  [medicineId]="medicineId"
  [regionPercentage]="regionPercentage"
  (closeModal)="showModalHospitals($event)"
  [experienceNumber]="experienceTotal"
>
</app-modal-pot-per-reg-hospitals>